import { useState } from 'react';

import Select, { type SelectOption } from '@rio-cloud/rio-uikit/Select';

import { Playground } from '../../../components/playground/Playground';
import {
    PlaygroundClasses,
    PlaygroundResponsiveClasses,
    PlaygroundClassesSpacer,
    PlaygroundPrintClasses,
} from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

import { spacings } from '../../../utils/spacings';
const spacingsWithoutZero = spacings.slice(1);
const spacingOptions: SelectOption[] = spacings.map(spacing => ({ id: spacing, label: `${spacing}px` }));

const paddingDirections = [
    { label: 'Surrounding', prefix: 'padding-' },
    { label: 'Horizontal', prefix: 'padding-x-' },
    { label: 'Vertical', prefix: 'padding-y-' },
    { label: 'Left', prefix: 'padding-left-' },
    { label: 'Right', prefix: 'padding-right-' },
    { label: 'Top', prefix: 'padding-top-' },
    { label: 'Bottom', prefix: 'padding-bottom-' },
];

export const Padding = () => (
    <div>
        <Headline anchor='padding'>Padding</Headline>
        <Playground example={<PaddingExample />} classes={paddingClasses} />
    </div>
);

const PaddingExample = () => {
    const [spacing, setSpacing] = useState('20');

    const handleSpacingChange = (option: SelectOption | undefined) => setSpacing(option?.id ?? '20');

    return (
        <div>
            <div className='max-width-300 margin-bottom-25'>
                <Select
                    id='padding-spacing-value'
                    label='Padding'
                    options={spacingOptions}
                    value={[spacing]}
                    onChange={handleSpacingChange}
                />
            </div>
            <div className='display-grid grid-cols-1 grid-cols-2-sm grid-cols-4-lg gap-20'>
                {paddingDirections.map(({ label, prefix }) => {
                    const className = `${prefix}${spacing}`;

                    return (
                        <div key={prefix}>
                            <Title>{label}</Title>
                            <div className='display-flex flex-column height-200 padding-15 overflow-hidden rounded bg-lightest'>
                                <div className='display-flex align-items-center justify-content-center flex-1-1'>
                                    <div className={`${className} rounded bg-info`}>
                                        <div className='width-50 height-50 rounded-inner bg-white shorthand-style' />
                                    </div>
                                </div>
                                <code className='text-center bg-none'>{className}</code>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const paddingClasses = (
    <>
        <PlaygroundClassesSpacer label='Pixel values' />
        <PlaygroundClasses label='Surrounding' prefix='padding-' classes={spacings} />
        <PlaygroundClasses label='Horizontal' prefix='padding-x-' classes={spacings} />
        <PlaygroundClasses label='Vertical' prefix='padding-y-' classes={spacings} />
        <PlaygroundClasses label='Left' prefix='padding-left-' classes={spacings} />
        <PlaygroundClasses label='Right' prefix='padding-right-' classes={spacings} />
        <PlaygroundClasses label='Top' prefix='padding-top-' classes={spacings} />
        <PlaygroundClasses label='Bottom' prefix='padding-bottom-' classes={spacings} />
        <PlaygroundClassesSpacer label='Percentage values' />
        <PlaygroundClasses label='Surrounding' prefix='padding-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Horizontal' prefix='padding-x-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Vertical' prefix='padding-y-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Left' prefix='padding-left-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Right' prefix='padding-right-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Top' prefix='padding-top-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundClasses label='Bottom' prefix='padding-bottom-' classes={spacingsWithoutZero} suffix='pct' />
        <PlaygroundResponsiveClasses />
        <PlaygroundPrintClasses />
    </>
);
